import { render } from "./LegacyMeasurementsPage.vue?vue&type=template&id=6fb11b3a&ts=true"
import script from "./LegacyMeasurementsPage.vue?vue&type=script&lang=ts"
export * from "./LegacyMeasurementsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__